module.exports = __webpack_public_path__ + "img/aal.b7546ff2.svg";